declare class SPA {
    static router:any;
}

declare var app: any;

var Components = window.Components = (function() {
    interface IBetItemControllerConfig {
        itemselector: string;
        toggleselector: string;
        detailedselector: string;
        url: string;
    }

    class BetItemController implements  Behaviours.IComponentController
    {
        private _config: IBetItemControllerConfig = <IBetItemControllerConfig>{
            itemselector: '[hst-betitem]',
            toggleselector: '[hst-toggle_betitem]',
            detailedselector: '[hst-betitem_detailed]',
            url: "/History/ToggleBetState",
        }

        load(element: HTMLElement, config: IBetItemControllerConfig) {
            $.extend(this._config, config);

            $(element).on('click', this._config.toggleselector, (e) => {
                this.betItemToggleHandler(e.currentTarget);
            });
        }

        private betItemToggleHandler(element) {
            var betItemNode = $(element).closest(this._config.itemselector);
            var isCollapsing = betItemNode.hasClass('m-expanded');

            var succes = (isCollapsing)
                ? () => {
                    betItemNode.removeClass('m-expanded');
                    betItemNode.find(this._config.detailedselector).empty();
                    app.disableLoading();
                }
                : () => {
                    betItemNode.addClass('m-expanded');
                    app.disableLoading();
                }

            app.enableLoading();
            Ajax.postJson(this._config.url,
                {
                    data: { betNumber: betItemNode.data('num'), isExpanded: isCollapsing },
                    success: succes
                });
            return false;
        }
    }

    return {
        BetItemController
    }
}());
